"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _get = _interopRequireDefault(require("lodash/get"));
var _ReduxForm = require("../../utils/ReduxForm.Functions");
var _translation = _interopRequireDefault(require("../../Translation/translation"));
var _BrixelAvatar = _interopRequireDefault(require("../BrixelAvatar"));
var _BrixelDropdownMini = _interopRequireDefault(require("../BrixelDropdownMini"));
var _BrixelButtonIcon = _interopRequireDefault(require("../BrixelButtonIcon"));
var _BrixelTextEditor = _interopRequireDefault(require("./BrixelTextEditor"));
var _ = require("../..");
var _lodash = require("lodash");
var _BrixelButtonPrimary = _interopRequireDefault(require("../BrixelButtonPrimary"));
var _luxon = require("luxon");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const BrixelReduxFormNotes = props => {
  const [newNote, setNewNote] = _react.default.useState('');
  const [editNoteText, setEditNoteText] = _react.default.useState('');
  const [noteList, setNoteList] = _react.default.useState([]);
  const [editNote, setEditNote] = _react.default.useState({
    id: '',
    active: false
  });
  const [noteOptionsOpen, setNoteOptionsOpen] = _react.default.useState({
    id: '',
    active: false
  });
  const {
    formName = 'Property',
    formValue,
    changeFieldValue,
    input,
    initialValue,
    label,
    loggedInUser,
    lang = 'en',
    user
  } = props;
  const noteRef = _react.default.useRef(null);
  (0, _react.useEffect)(() => {
    if (JSON.stringify(formValue.teamNotes) === JSON.stringify(initialValue.teamNotes) && input) {
      setNoteList((0, _get.default)(initialValue, input?.name, []));
      setEditNote({
        id: '1',
        active: false
      });
    }
  }, [(0, _get.default)(formValue, input.name, []).length]);
  console;
  const onChangeNote = val => {
    if (input) {
      const defVal = [...(0, _get.default)(initialValue, input.name, [])];
      defVal.push({
        createdAt: new Date().valueOf(),
        updatedAt: new Date().valueOf(),
        author: loggedInUser.id,
        authorName: loggedInUser.name,
        text: val,
        id: defVal.length
      });
      changeFieldValue(formName, input.name, defVal);
      const r = (Math.random() + 1).toString(36).substring(7);
      changeFieldValue(formName, 'reloadPage', r);
      setNewNote(val);
    }
  };
  const onEditNote = (val, index) => {
    if (input) {
      const defVal = [...(0, _get.default)(formValue, input.name, [])];
      defVal[index].text = val;
      defVal[index].updatedAt = new Date().valueOf();
      changeFieldValue(formName, input.name, defVal);
    }
  };
  const onCancelNote = index => {
    if (input) {
      const defVal = [...(0, _get.default)(formValue, input.name, [])];
      const initVal = [...(0, _get.default)(initialValue, input.name, [])];
      defVal[index].text = initVal[index].text;
      defVal[index].updatedAt = initVal[index].updatedAt;
      setEditNote({
        id: '',
        active: false
      });
    }
  };
  const deleteNote = (e, index) => {
    if (e) e.preventDefault();
    if (input) {
      const defVal = [...(0, _get.default)(formValue, input.name, [])];
      defVal.splice(index, 1);
      const val = [...noteList];
      val.splice(index, 1);
      setNoteList(val);
      const r = (Math.random() + 1).toString(36).substring(7);
      changeFieldValue(formName, 'reloadPage', r);
      changeFieldValue(formName, input.name, defVal);
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "add-note-container w-perc-100 dis-fl-col p-2 mb-2"
  }, label && (/*#__PURE__*/_react.default.createElement("label", {
    className: "brixel-label",
    "data-testid": "label"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "va-tb "
  }, label))), /*#__PURE__*/_react.default.createElement("div", {
    className: "text-container dis-fl-row bgText25 brdRadius p-2 mb-1"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "div"
  }, /*#__PURE__*/_react.default.createElement(_BrixelAvatar.default, {
    avatarImg: (0, _get.default)(user, 'avatarUrl', ''),
    name: (0, _get.default)(user, 'name', user?.email),
    profileId: (0, _get.default)(user, 'id', '')
  })), /*#__PURE__*/_react.default.createElement(_BrixelTextEditor.default, {
    editorClassName: "new-note brdRadius brdText100 brdSmall",
    wrapperClassName: "ml-2 dis-fl-col",
    toolbarClassName: "bgText25",
    input: {
      onChange: val => onChangeNote(val),
      value: newNote,
      name: 'newNote'
    },
    placeholder: (0, _translation.default)('Write your note here', lang)
  })), noteList.map((event, i) => (/*#__PURE__*/_react.default.createElement("div", {
    className: "single-event p-2 w-perc-100 dis-fl-row a-t bgText25 brdRadius brdSmall brdText100 note mb-2",
    id: `note-${i}`,
    key: `chrDt_${i.toString()}`
  }, editNote.id === event.id && editNote.active ? (/*#__PURE__*/_react.default.createElement("div", {
    className: "dis-fl-col w-perc-100"
  }, /*#__PURE__*/_react.default.createElement(_BrixelTextEditor.default, {
    editorClassName: "new-note brdRadius brdText100 brdSmall",
    wrapperClassName: "dis-fl-col",
    input: {
      onChange: val => onEditNote(val, i),
      value: editNoteText,
      name: 'editNoteText'
    },
    currentInitialValue: editNoteText,
    placeholder: (0, _translation.default)('Write your note here', lang)
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: 'pt-1'
  }, /*#__PURE__*/_react.default.createElement(_BrixelButtonPrimary.default, {
    label: "Cancel",
    onClick: () => onCancelNote(i),
    theme: "red",
    className: 'jc-fs',
    rounded: true,
    small: true
  })))) : (/*#__PURE__*/_react.default.createElement("div", {
    className: "dis-fl-col w-perc-100"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "dis-f a-fs jc-b"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "w-perc-100"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "description body pb-small-4",
    dangerouslySetInnerHTML: {
      __html: _.Helpers.sanitizeText(event.text || '')
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "dis-fl-row"
  }, (0, _lodash.has)(event, 'authorName') && (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: "fsize-100 txtText800"
  }, event.authorName))), /*#__PURE__*/_react.default.createElement("span", {
    className: "fsize-100 txtText400 ml-2"
  }, _luxon.DateTime.fromMillis(event.updatedAt, {
    locale: lang
  }).toFormat('dd LLL yy, H:mm')))), /*#__PURE__*/_react.default.createElement("div", {
    className: "dis-f a-t pos-r"
  }, /*#__PURE__*/_react.default.createElement(_BrixelButtonIcon.default, {
    bgTransparent: true,
    small: true,
    theme: "text",
    themeSat: 700,
    icon: "options-vertical",
    onClick: () => {
      setEditNote({
        id: '',
        active: false
      });
      setNoteOptionsOpen({
        id: event.id,
        active: !noteOptionsOpen.active
      });
    }
  }), noteOptionsOpen.id === (0, _get.default)(event, 'id') && noteOptionsOpen.active && (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_BrixelDropdownMini.default, {
    topOffset: 38,
    rightAligned: true,
    ref: noteRef,
    links: [{
      label: (0, _translation.default)('Edit', lang),
      clickFunc: () => {
        setNoteOptionsOpen({
          id: '',
          active: false
        });
        setEditNote({
          id: event.id,
          active: !editNote.active
        });
        setEditNoteText(event.text);
      }
    }, {
      label: (0, _translation.default)('Delete', lang),
      className: 'txtRed400',
      clickFunc: e => {
        deleteNote(e, i);
        setNoteOptionsOpen({
          id: '',
          active: false
        });
      }
    }]
  })))))))))));
};
const mapStateToProps = (state, ownProps) => {
  const formName = ownProps.formName || 'Property';
  const formValue = (0, _get.default)(state, `brixelForm['${formName}'].values`, []);
  const initialValue = (0, _get.default)(state, `brixelForm['${formName}'].initialValues`, []);
  return {
    activeSingleProperty: initialValue,
    currentInitialValue: (0, _get.default)(initialValue, ownProps.input.name, null),
    currentValue: (0, _get.default)(formValue, ownProps.input.name, null),
    errors: (0, _get.default)(state, 'brixelForm.Property.syncErrors', {}),
    form: formName,
    loggedInUser: (0, _get.default)(state, 'user.loggedInUser', {}),
    formValue,
    initialValue,
    lang: (0, _get.default)(state, 'common.language.code', (0, _get.default)(state, 'common.language', 'en'))
  };
};
const mapDispatchToProps = dispatch => ({
  changeFieldValue(form, field, value) {
    dispatch((0, _ReduxForm.change)(form, field, value));
  }
});
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BrixelReduxFormNotes);